import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningIcon from '@mui/icons-material/Warning';

function DeleteConfirmationModal({ 
  open, 
  onClose, 
  onConfirm, 
  title = 'Confirmar Exclusão',
  message = 'Tem certeza que deseja excluir este item?',
  itemName = ''
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ 
        bgcolor: '#d32f2f',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <DeleteIcon />
        {title}
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 2 }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2,
          mb: 2,
          color: '#d32f2f'
        }}>
          <WarningIcon sx={{ fontSize: 40 }} />
          <Typography variant="h6">
            Atenção!
          </Typography>
        </Box>
        <Typography>
          {message}
        </Typography>
        {itemName && (
          <Typography sx={{ 
            mt: 2, 
            fontWeight: 'bold',
            fontStyle: 'italic'
          }}>
            Item: {itemName}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          size="large"
          startIcon={<DeleteIcon />}
        >
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmationModal;
